import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    '&:not(:first-child)': {
      marginTop: theme.spacing(4),
    },
    '&:last-child': {
      marginBottom: theme.spacing(2),
    },
  }
}));

type FormStepProps = {
  children: React.ReactNode,
}

const FormStep = ({ children }: FormStepProps) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {children}
    </div>
  )
};

export default FormStep;
